import React from "react";
// BASE components
import BASELoading from "../../../../../../../@BASE/core/BASELoading";
// material-ui components
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
// Custom components
import Instructions from "../components/Instructions";
import { ImageAttribution } from "../components/ImageAttribution";
import EMentor from "../components/EMentor";

export default function PEObservationEvent(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>
      <Typography className="text-16 font-bold p-16 pb-0">
        Page Instructions:
      </Typography>

      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
        noInstructions
      />
      <Typography className="text-16 font-bold p-16 pb-0">
        Page Content:
      </Typography>

      {data.core.map((slide, index) => (
        <div key={index}>
          <Typography className="text-14 font-bold p-16 pb-0">
            Slide {index + 1}:
          </Typography>
          <Grid container spacing={0}>
            <Grid item xs={12} className="mx-16">
              <ImageAttribution attribution={slide.media} tl={tl} dir={dir} />
            </Grid>
          </Grid>

          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Caption:
                </Typography>
                <Divider className="my-16" />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={4} sm={2}>
                <Typography className="text-14 font-semibold m-0">
                  Text (TL):
                </Typography>
              </Grid>
              <Grid item xs={8} sm={10}>
                <Typography className={`${tl} m-0`} dir={dir}>
                  {slide.text_tl}
                </Typography>
              </Grid>
              <Grid item xs={4} sm={2}>
                <Typography className="text-14 font-semibold m-0">
                  Text (EN):
                </Typography>
              </Grid>
              <Grid item xs={8} sm={10}>
                <Typography className="text-14 m-0">{slide.text_en}</Typography>
              </Grid>
            </Grid>
          </Paper>
        </div>
      ))}
      {data.eMentor.length !== 0 && (
        <EMentor
          eMentor={data.eMentor}
          tl={tl}
          dir={dir}
          componentCommentsCount={componentCommentsCount}
        />
      )}
    </div>
  );
}
